<div class="maxContainerWidth">
    <h3 class="heading">
        Read More Stories
    </h3>
    <div class="storiesWrap flex justify-between items-center">
        <ng-container *ngFor="let story of storyList">
            <div class="story">
                <div class="storyImg">
                    <img src="assets/images/case-study-page/{{story.imgSrc}}" alt="">
                </div>
                <div class="storyDate">
                    {{story.date}}
                </div>
                <div class="storyTitle">
                    {{story.title}}
                </div>
                <div class="storyDescription">
                    {{story.description}}
                </div>
            </div>
        </ng-container>
        <div class="border border1"></div>
        <div class="border border2"></div>
        <div class="border border3"></div>
    </div>
</div>